// Author Lin
// Date 2024-07-25 10:59:28

class SithMesInventoryPackageMaterial {
    constructor({
                    id = null,
                    packageId = '',
                    packageNo = '',
                    materialId = '',
                    materialName = '',
                    quantity = '',
                    bindingState = '',
                    packageCountWorker = '',
                    remark = '',
                    unpackingTime = '',
                    unpackingCheckWorkerLogin = '',
                    unpackingOrNot = '',
                    accountMatchActualSituationOrNot = '',
                    notMatchReason = '',
                    unpackingAttachmentOrNot = '',
                    unpackingAttachment = '',
                    unpackingAttachmentList = ''
                }
                    = {}) {
        this.id = id;
        this.packageId = packageId;
        this.packageNo = packageNo;
        this.materialId = materialId;
        this.materialName = materialName;
        this.quantity = quantity;
        this.bindingState = bindingState;
        this.packageCountWorker = packageCountWorker;
        this.remark = remark;
        this.unpackingTime = unpackingTime;
        this.unpackingCheckWorkerLogin = unpackingCheckWorkerLogin;
        this.unpackingOrNot = unpackingOrNot;
        this.accountMatchActualSituationOrNot = accountMatchActualSituationOrNot;
        this.notMatchReason = notMatchReason;
        this.unpackingAttachmentOrNot = unpackingAttachmentOrNot;
        this.unpackingAttachment = unpackingAttachment;
        this.unpackingAttachmentList = unpackingAttachmentList;
    }
}

function newEntity() {
    return new SithMesInventoryPackageMaterial();
}

const packageVoConfigs = [
    {
        key: 'packageNo',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.packageNo',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'boxNo',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.boxNo',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packageType',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.packageType',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '内箱'},
                {value: '2', text: '外箱'},
                {value: '3', text: '虚拟箱'}
            ]
        }
    },
    {
        key: 'materialId',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.materialId',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialName',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.materialName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.materialCode',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryCode',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.deliveryCode',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unit',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.unit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'cid',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.cid',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryMaterialRemark',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.deliveryMaterialRemark',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDesc',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.materialDesc',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantity',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.quantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bindingState',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.bindingState',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '已解绑'},
                {value: '1', text: '绑定'}
            ]
        }
    },
    {
        key: 'packageCountWorkerName',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.packageCountWorkerName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTime',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.createdTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packFinishTime',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.packFinishTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCountWorkerName',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.materialCountWorkerName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.remark',
        sortable: true,
        isDetail: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'exitPermitStatus',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.exitPermitStatus',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '未提交申请'},
                {value: '2', text: '审批中'},
                {value: '3', text: '申请已通过'},
                {value: '4', text: '申请被驳回'}
            ]
        }
    },
    {
        key: 'shipper',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.shipper',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptCompany',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.receiptCompany',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transporter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.transporter',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'licensePlate',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.licensePlate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingAttachmentOrNot',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.unpackingAttachmentOrNot',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingAttachmentList',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.unpackingAttachmentList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    }
]

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'packageNo',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.packageNo',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'boxNo',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.boxNo',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'packageType',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.packageType',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '内箱'},
                    {value: '2', text: '外箱'},
                    {value: '3', text: '虚拟箱'}
                ]
            }
        },
        {
            key: 'materialId',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.materialId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialName',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.materialName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialCode',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.materialCode',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliveryCode',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.deliveryCode',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unit',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.unit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'cid',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.cid',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'deliveryMaterialRemark',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.deliveryMaterialRemark',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialDesc',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.materialDesc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'quantity',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.quantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bindingState',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.bindingState',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: '已解绑'},
                    {value: '1', text: '绑定'}
                ]
            }
        },
        {
            key: 'packageCountWorkerName',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.packageCountWorkerName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdTime',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.createdTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'packFinishTime',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.packFinishTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialCountWorkerName',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.materialCountWorkerName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'exitPermitStatus',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.exitPermitStatus',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '未提交申请'},
                    {value: '2', text: '审批中'},
                    {value: '3', text: '申请已通过'},
                    {value: '4', text: '申请被驳回'}
                ]
            }
        },
        {
            key: 'shipper',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.shipper',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'receiptCompany',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.receiptCompany',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'transporter',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.transporter',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'licensePlate',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.licensePlate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unpackingTime',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.unpackingTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unpackingCheckWorkerName',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.unpackingCheckWorkerName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unpackingOrNot',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.unpackingOrNot',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'accountMatchActualSituationOrNot',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.accountMatchActualSituationOrNot',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'notMatchReason',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.notMatchReason',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unpackingAttachmentOrNot',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.unpackingAttachmentOrNot',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unpackingAttachmentList',
            label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.unpackingAttachmentList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const unpackingVoConfigs = [
    {
        key: 'packageNo',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.packageNo',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'boxNo',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.boxNo',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packageType',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.packageType',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: '内箱'},
                {value: '2', text: '外箱'},
                {value: '3', text: '虚拟箱'}
            ]
        }
    },
    {
        key: 'materialId',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.materialId',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialName',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.materialName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.materialCode',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryCode',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.deliveryCode',
        sortable: true,
        isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unit',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.unit',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'cid',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.cid',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryMaterialRemark',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.deliveryMaterialRemark',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDesc',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.materialDesc',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantity',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.quantity',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bindingState',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.bindingState',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '0', text: '已解绑'},
                {value: '1', text: '绑定'}
            ]
        }
    },
    {
        key: 'packageCountWorkerName',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.packageCountWorkerName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCountWorkerName',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.materialCountWorkerName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.remark',
        sortable: true,
        isDetail: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingTime',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.unpackingTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingCheckWorkerName',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.unpackingCheckWorkerName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingOrNot',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.unpackingOrNot',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'accountMatchActualSituationOrNot',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.accountMatchActualSituationOrNot',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'notMatchReason',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.notMatchReason',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingAttachmentOrNot',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.unpackingAttachmentOrNot',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingAttachmentList',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.grid.unpackingAttachmentList',
        sortable: true,
        isDetail: true,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
        }
    }
]

const filter = {
    idFilter: '',
    idListFilter: [],
    packageIdListFilter: [],
    packageIdFilter: '',
    packageNoFilter: '',
    boxNoFilter: '',
    packageTypeFilter: '',
    materialIdFilter: '',
    materialNameFilter: '',
    quantityFilter: '',
    bindingStateFilter: '',
    packageCountWorkerNameFilter: '',
    createdTimeRteFilter: '',
    createdTimeLteFilter: '',
    packFinishTimeRteFilter: '',
    packFinishTimeLteFilter: '',
    materialCountWorkerNameFilter: '',
    exitPermitStatusFilter: '',
    shipperFilter: '',
    receiptCompanyFilter: '',
    transporterFilter: '',
    licensePlateFilter: '',
    projectCodeFilter: '',
    materialCodeFilter: '',
    deliveryCodeFilter: '',
    unpackingTimeRteFilter: '',
    unpackingTimeLteFilter: '',
    unpackingCheckWorkerNameFilter: '',
    unpackingOrNotFilter: '',
    accountMatchActualSituationOrNotFilter: '',
    notMatchReasonFilter: '',
    unpackingAttachmentOrNotFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'packageIdFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.packageId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryPackage'
            , correspondingField: 'id'
        }
    },
    {
        key: 'packageNoFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.packageNo',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryPackage'
            , correspondingField: 'packageNo'
            , fieldsBindingByEntityModalSelected: '{"packageId":"id"}'
        }
    },
    {
        key: 'boxNoFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.boxNo',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryPackage'
            , correspondingField: 'boxNo'
            , fieldsBindingByEntityModalSelected: '{"packageId":"id"}'
        }
    },
    {
        key: 'packageTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.packageType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '内箱'},
                {value: '2', text: '外箱'},
                {value: '3', text: '虚拟箱'}
            ]
        }
    },
    {
        key: 'materialNameFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.materialName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryDeliveryMaterial'
            , correspondingField: 'deliveryDescription'
            , fieldsBindingByEntityModalSelected: '{"materialId":"id"}'
        }
    },
    {
        key: 'quantityFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.quantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bindingStateFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.bindingState',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '已解绑'},
                {value: '1', text: '绑定'}
            ]
        }
    },
    {
        key: 'packageCountWorkerNameFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.packageCountWorkerName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packFinishTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.packFinishTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packFinishTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.packFinishTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCountWorkerNameFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.materialCountWorkerName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'exitPermitStatusFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.exitPermitStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '未提交申请'},
                {value: '2', text: '审批中'},
                {value: '3', text: '申请已通过'},
                {value: '4', text: '申请被驳回'}
            ]
        }
    },
    {
        key: 'shipperFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.shipper',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptCompanyFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.receiptCompany',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transporterFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.transporter',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'licensePlateFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.licensePlate',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.deliveryCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.unpackingTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.unpackingTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingCheckWorkerNameFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.unpackingCheckWorkerName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingOrNotFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.unpackingOrNot',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'accountMatchActualSituationOrNotFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.accountMatchActualSituationOrNot',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'notMatchReasonFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.notMatchReason',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingAttachmentOrNotFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.unpackingAttachmentOrNot',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    }
];
const packageFilterConfigs = [
    {
        key: 'packageIdFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.packageId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryPackage'
            , correspondingField: 'id'
        }
    },
    {
        key: 'packageNoFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.packageNo',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryPackage'
            , correspondingField: 'packageNo'
            , fieldsBindingByEntityModalSelected: '{"packageId":"id"}'
        }
    },
    {
        key: 'boxNoFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.boxNo',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryPackage'
            , correspondingField: 'boxNo'
            , fieldsBindingByEntityModalSelected: '{"packageId":"id"}'
        }
    },
    {
        key: 'packageTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.packageType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '内箱'},
                {value: '2', text: '外箱'},
                {value: '3', text: '虚拟箱'}
            ]
        }
    },
    {
        key: 'materialNameFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.materialName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryDeliveryMaterial'
            , correspondingField: 'deliveryDescription'
            , fieldsBindingByEntityModalSelected: '{"materialId":"id"}'
        }
    },
    {
        key: 'quantityFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.quantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bindingStateFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.bindingState',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '已解绑'},
                {value: '1', text: '绑定'}
            ]
        }
    },
    {
        key: 'packageCountWorkerNameFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.packageCountWorkerName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packFinishTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.packFinishTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'packFinishTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.packFinishTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCountWorkerNameFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.materialCountWorkerName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'exitPermitStatusFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.exitPermitStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '未提交申请'},
                {value: '2', text: '审批中'},
                {value: '3', text: '申请已通过'},
                {value: '4', text: '申请被驳回'}
            ]
        }
    },
    {
        key: 'shipperFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.shipper',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'receiptCompanyFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.receiptCompany',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'transporterFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.transporter',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'licensePlateFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.licensePlate',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.deliveryCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];
const unpackingFilterConfigs = [
    {
        key: 'packageNoFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.packageNo',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryPackage'
            , correspondingField: 'packageNo'
            , fieldsBindingByEntityModalSelected: '{"packageId":"id"}'
        }
    },
    {
        key: 'boxNoFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.boxNo',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryPackage'
            , correspondingField: 'boxNo'
            , fieldsBindingByEntityModalSelected: '{"packageId":"id"}'
        }
    },
    {
        key: 'packageTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.packageType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '内箱'},
                {value: '2', text: '外箱'},
                {value: '3', text: '虚拟箱'}
            ]
        }
    },
    {
        key: 'materialNameFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.materialName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryDeliveryMaterial'
            , correspondingField: 'deliveryDescription'
            , fieldsBindingByEntityModalSelected: '{"materialId":"id"}'
        }
    },
    {
        key: 'bindingStateFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.bindingState',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '已解绑'},
                {value: '1', text: '绑定'}
            ]
        }
    },
    {
        key: 'packageCountWorkerNameFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.packageCountWorkerName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCountWorkerNameFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.materialCountWorkerName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'deliveryCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.deliveryCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.unpackingTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.unpackingTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingCheckWorkerNameFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.unpackingCheckWorkerName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingOrNotFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.unpackingOrNot',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'accountMatchActualSituationOrNotFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.accountMatchActualSituationOrNot',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'notMatchReasonFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.notMatchReason',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingAttachmentOrNotFilter',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.filter.unpackingAttachmentOrNot',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    }
];


const packageEntityConfigs = [
    {
        key: 'packageNo',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.packageNo',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryPackage'
            , correspondingField: 'packageNo'
            , fieldsBindingByEntityModalSelected: '{"packageId":"id"}'
        }
    },
    {
        key: 'materialName',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.materialName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryDeliveryMaterial'
            , correspondingField: 'deliveryDescription'
            , fieldsBindingByEntityModalSelected: '{"materialId":"id"}'
        }
    },
    {
        key: 'quantity',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bindingState',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.bindingState',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '已解绑'},
                {value: '1', text: '绑定'}
            ]
        }
    },
    {
        key: 'packageCountWorker',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.packageCountWorker',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]
const unpackingEntityConfigs = [
    {
        key: 'packageNo',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.packageNo',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryPackage'
            , correspondingField: 'packageNo'
            , fieldsBindingByEntityModalSelected: '{"packageId":"id"}'
        }
    },
    {
        key: 'materialName',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.materialName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryDeliveryMaterial'
            , correspondingField: 'deliveryDescription'
            , fieldsBindingByEntityModalSelected: '{"materialId":"id"}'
        }
    },
    {
        key: 'packageCountWorker',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.packageCountWorker',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingTime',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.unpackingTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingCheckWorkerLogin',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.unpackingCheckWorkerLogin',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'unpackingOrNot',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.unpackingOrNot',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'accountMatchActualSituationOrNot',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.accountMatchActualSituationOrNot',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'notMatchReason',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.notMatchReason',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingAttachmentOrNot',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.unpackingAttachmentOrNot',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingAttachment',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.unpackingAttachment',
        sortable: true,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'unpackingAttachmentList'
        }
    }
]
const entityFormConfigs = [
    {
        key: 'packageNo',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.packageNo',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryPackage'
            , correspondingField: 'packageNo'
            , fieldsBindingByEntityModalSelected: '{"packageId":"id"}'
        }
    },
    {
        key: 'materialName',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.materialName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryDeliveryMaterial'
            , correspondingField: 'deliveryDescription'
            , fieldsBindingByEntityModalSelected: '{"materialId":"id"}'
        }
    },
    {
        key: 'quantity',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bindingState',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.bindingState',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '已解绑'},
                {value: '1', text: '绑定'}
            ]
        }
    },
    {
        key: 'packageCountWorker',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.packageCountWorker',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingTime',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.unpackingTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingCheckWorkerLogin',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.unpackingCheckWorkerLogin',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'unpackingOrNot',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.unpackingOrNot',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'accountMatchActualSituationOrNot',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.accountMatchActualSituationOrNot',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'notMatchReason',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.notMatchReason',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingAttachmentOrNot',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.unpackingAttachmentOrNot',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unpackingAttachmentList',
        label: 'label.sith.inventory.sithMesInventoryPackageMaterial.entity.unpackingAttachment',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'unpackingAttachment'
        }
    }
]

export {
    SithMesInventoryPackageMaterial, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs, packageFilterConfigs, unpackingFilterConfigs
    , packageEntityConfigs, unpackingEntityConfigs
    , packageVoConfigs, unpackingVoConfigs
}
